/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb5_Workflow_3Inputs */

const en_visa_eb5_workflow_3 = /** @type {(inputs: Visa_Eb5_Workflow_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Track post-filing requirements, including documentation tied to the investment and job creation.`)
};

const pt_visa_eb5_workflow_3 = /** @type {(inputs: Visa_Eb5_Workflow_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acompanhar os requisitos posteriores à apresentação, incluindo documentação vinculada ao investimento e à criação de empregos.`)
};

const es_visa_eb5_workflow_3 = /** @type {(inputs: Visa_Eb5_Workflow_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dar seguimiento a los requisitos posteriores a la presentación, incluyendo la documentación vinculada a la inversión y creación de empleos.`)
};

/**
* | output |
* | --- |
* | "Track post-filing requirements, including documentation tied to the investment and job creation." |
*
* @param {Visa_Eb5_Workflow_3Inputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb5_workflow_3 = /** @type {((inputs?: Visa_Eb5_Workflow_3Inputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb5_Workflow_3Inputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb5_workflow_3(inputs)
	if (locale === "es") return es_visa_eb5_workflow_3(inputs)
	return en_visa_eb5_workflow_3(inputs)
});